// import React from 'react';

// const ClinicBanner = ({ data }) => {
//   if (!data) {
//     console.warn('ClinicBanner: data prop is undefined');
//     return null;
//   }

//   const { id, image, heading, body } = data;

//   return (
//     <section id={id} className="w-full ava-section-gap px-4 md:px-8 bg-white">
//       <div className="max-w-6xl mx-auto">
//         <div
//           className="relative w-full overflow-hidden rounded-xl"
//           style={{ minHeight: 'clamp(160px, 22vw, 200px)' }}
//         >
        

//           <div
//             className="absolute inset-0 secondary-bg "
           
//           />

//           <div className="relative z-10 w-full h-full flex items-center">
//             <div
//               className="px-8 md:px-12 py-8 md:py-10 flex flex-col gap-3"
              
//             >
//               <h2
//                 className=" ava-heading-lg text-black"
        
//               >
//                 {heading}
//               </h2>

//               {body && (
//                 <p
//                   className="ava-text-body text-black"
//                   style={{
//                     opacity: 0.92,
//                   }}
//                 >
//                   {body}
//                 </p>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default ClinicBanner;
import React from 'react';
import { useNavigate } from 'react-router-dom';

const ClinicBanner = ({ data }) => {
  const navigate = useNavigate();

  if (!data) {
    console.warn('ClinicBanner: data prop is undefined');
    return null;
  }

  const { id, heading, body } = data;

  return (
    <section id={id} className="w-full py-6 px-4 md:px-8 ava-card-bg">
      <div className="max-w-6xl mx-auto">
        <div className="w-full secondary-bg rounded-xl flex flex-col md:flex-col items-start justify-between gap-6 px-8 md:px-12 py-8 md:py-10">
          
          {/* Left: heading + body */}
          <div className="flex flex-col gap-3" style={{ maxWidth: '780px' }}>
            <h2 className="ava-heading-lg text-black">
              {heading}
            </h2>
            {body && (
              <p className="ava-text-body text-black" style={{ opacity: 0.92 }}>
                {body}
              </p>
            )}
          </div>

          {/* Right: button */}
          <button
            className="btn-primary flex-shrink-0 hover:border-white transiton-all duration-200"
            style={{
              // border:hover?"2px solid white":""
            }}

            onClick={() => navigate('/book-appointment')}
          >
            Book an Appointment
          </button>
        </div>
      </div>
    </section>
  );
};

export default ClinicBanner;